import { render, staticRenderFns } from "./ReservasCuenta.vue?vue&type=template&id=1ab32206"
import script from "./ReservasCuenta.vue?vue&type=script&lang=js"
export * from "./ReservasCuenta.vue?vue&type=script&lang=js"
import style0 from "./ReservasCuenta.vue?vue&type=style&index=0&id=1ab32206&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports